import React from 'react';
import { IIconProps } from './utils';

export const Print = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 26 26" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M5.5 9.25V3C5.5 2.30964 6.05964 1.75 6.75 1.75H14.25M5.5 9.25H20.5M5.5 9.25C3.42893 9.25 1.75 10.9289 1.75 13V15.5C1.75 17.5711 3.42893 19.25 5.5 19.25H7.375M19.25 1.75C19.9404 1.75 20.5 2.30964 20.5 3V9.25M20.5 9.25C22.5711 9.25 24.25 10.9289 24.25 13V15.5C24.25 17.5711 22.5711 19.25 20.5 19.25H18.625M18.625 19.25V14.25H14.25H7.375V19.25M18.625 19.25V23C18.625 23.6904 18.0654 24.25 17.375 24.25H8.625C7.93464 24.25 7.375 23.6904 7.375 23V19.25" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" />
  </svg>
);
